<template>
    <ContentOrLoading>
        <b-row v-if="! loading">
            <b-col cols="12" v-if="! seccion_seleccionada">
                <b-row>
                    <b-col cols="12">
                        <h2 class="m-0 h1 text-uppercase">Selecciona el sector pinchando en el mapa</h2>
                    </b-col>
                    <b-col cols="12">
                        <SvgSectionsComponent
                            :secciones="secciones"
                            @clickZona="seccionSeleccionada"
                        />
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12" v-else>
                <b-row>
                    <b-col cols="12" v-if="! seccion_seleccionada.tiene_secciones">
                        <b-row>
                            <div class="col-12 justify-content-between d-flex">
                                <span class="m-0 h1 text-uppercase">{{ $t('nuevo_abono.elige_asientos') }}</span>
                                <button @click="volver" class="h6 button small-button m-0"><i class="fa fa-redo"></i> Volver</button>
                            </div>
                            <b-col cols="12" class="pt-3">
                                <b-breadcrumb>
                                    <b-breadcrumb-item 
                                        v-for="(item, index) in breadcrumbs" 
                                        :key="index" 
                                        @click="breadcrumbs.length -1 == index ? null : goTo(item, index)"
                                        :active="breadcrumbs.length -1 == index"
                                    >
                                        {{ item.name }}
                                    </b-breadcrumb-item>
                                </b-breadcrumb>
                            </b-col>
                            <b-col cols="12" v-show="!cargando_zonas">
                                <transition name="fade" mode="out-in">
                                    <div class="row" key="seccion" id="zonas"> 
                                        <b-col cols="12">
                                            <h3 class="subtitle h3 light mb-3 ">A) {{ $t('partido.pinchando_mapa') }}:</h3>
                                        </b-col>
                                        <div class="col-lg-8" v-if="!cargando_zonas">
                                            <div class="lightgray-content">
                                                <SvgSectionComponent
                                                    :zonas="zonas_formated"
                                                    :seccion="seccion_seleccionada"
                                                    @clickZona="regionFinalSeleccionada"
                                                    @cargado="cargando_zonas = false"
                                                />												
                                            </div>
                                        </div>
                                        <div class="col-12 col-lg-4">
                                            <h3 class="subtitle h3 light mb-3 ">B) {{ $t('partido.tabla') }}:</h3>
                                            <div class="lightgray-content p-2 pb-0">
                                                <TablaSectoresComponent 
                                                    :zonas="zonas_formated" 
                                                    @goTo="clickTablaSectores"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </transition>
                            </b-col>
                        </b-row>                        
                    </b-col>
                    <b-col cols="12" v-else>
                        <b-row>
                            <div class="col-12 justify-content-between d-flex">
                                <h2 class="m-0 h1 text-uppercase text-center pb-3">{{ $t('partido.pinchando_mapa') }}</h2>
                                <button @click="volver" class="h6 button small-button m-0"><i class="fa fa-redo"></i> Volver</button>
                            </div>
                            <b-col cols="12" class="pt-3">
                                <b-breadcrumb>
                                    <b-breadcrumb-item 
                                        v-for="(item, index) in breadcrumbs"
                                        :key="index" 
                                        @click="breadcrumbs.length -1 == index ? null : goTo(item, index)"
                                        :active="breadcrumbs.length -1 == index"
                                    >
                                        {{ item.name }}
                                    </b-breadcrumb-item>
                                </b-breadcrumb>
                            </b-col>
                            <div class="col-12" v-show="!cargando_zonas">
                                <transition name="fade" mode="out-in">
                                    <div class="row" key="secciones" id="zonas">
                                        <div class="col-lg-12">
                                            <div class="lightgray-content">
                                                <SvgSectionComponent
                                                    :zonas="secciones"
                                                    :seccion="seccion_seleccionada"
                                                    @clickZona="seccionSeleccionada"
                                                    @cargado="cargando_zonas = false"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </transition>
                            </div>
                            <div v-if="cargando_zonas" class="col-12 text-center" style="height: 400px">
                                <LoaderComponent/>
                            </div>
                        </b-row>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </ContentOrLoading>
    
</template>

<script>
    import SvgSectionsComponent from './components/SvgSectionsComponent.vue';
    import TablaSectoresComponent from '@/components/backend/stepper/components/TablaSectoresComponent.vue';
    import SvgSectionComponent from './components/SvgSectionComponent.vue';

    export default {
        data() {
            return {
                secciones: [],
                loading: true,
                seccion_seleccionada: false,
                breadcrumbs: [],
                cargando_zonas: false,
                zonas: []
            }
        },
        created() {
            this.getSecciones();

            this.breadcrumbs.push({
                name: 'Inicio'
            })
        },
        computed: {
            recinto(){
                return this.$store.getters.getRecinto;
            },
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            zonas_formated() {
                var array = [];
                for(var zona in this.zonas) {
                    array.push(this.zonas[zona]);
                    var disponible = array[zona].tipos_abonos.length > 0 && array[zona].esta_disponible ? true : false;
                    array[zona].esta_disponible = disponible;
                }

                return array;                
            },
        },
        methods: {
            getSecciones() {            
                this.loading = true;

                this.$store.dispatch(this.config.getVuexAlias('back.abonos.taquilla.recinto.secciones'), {
                    filters: {},
                    recinto_id: this.recinto.id,
                    lista_id: this.lista_abonados.id
                }).then(res => {
                    this.secciones = res.data.data;
                    this.loading = false;
                });
            },
            seccionSeleccionada(seccion) {
                this.breadcrumbs.push({
                    name: seccion.name,
                    id: seccion.id,
                    tiene_secciones: seccion.tiene_secciones
                })
                this.cargando_zonas = true;
                this.zonas = [];
                this.getSeccionRegiones(seccion);            
                this.seccion_seleccionada = seccion;
            },
            getSeccionRegiones(seccion) {
                this.cargando_zonas = true;
                const params = {
                    filters: {},
                    seccion_id: seccion.id,
                    recinto_id: this.recinto.id,
                    lista_id: this.lista_abonados.id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.abonos.taquilla.recinto.secciones.regiones'), params).then(res => {
                    if(! seccion.tiene_secciones) {
                        this.zonas = this.zonas.concat(res.data);
                    } else {
                        this.secciones = res.data.data;
                    }                
                }).finally(() => {
                    this.cargando_zonas = false;
                });
            },
            volver() {
                let index = this.breadcrumbs.length -2;
                this.goTo(this.breadcrumbs[index], index)
            },
            goTo(item, index) {
                if(item.name == 'Inicio') {
                    this.reset();
                } else {
                    this.breadcrumbs.splice(index);
                    this.seccionSeleccionada(item);
                }
            },
            reset() {
                this.breadcrumbs = [{
                    name: 'Inicio'
                }];
                this.seccion_seleccionada = null;
                this.zonas = [];
                this.getSecciones();
            },
            regionFinalSeleccionada(zona) {
                this.$emit('terminar', 2, zona, null);
            },
            clickTablaSectores(paso, zona) {
                this.$emit('terminar', paso, zona, null);
            }
        },
        components: {
            SvgSectionsComponent, TablaSectoresComponent, SvgSectionComponent
        }
    }
</script>